/** @format */

import React, { useState } from "react";
import {
  Nav,
  Form,
  Card,
  Container,
  Image,
  Dropdown,
  Navbar,
  Button,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

// Import selectors & action from setting store
import * as SettingSelector from "../../../../store/setting/selectors";
import logo from "src/assets/images/logo-FirstLink.png";

// Redux Selector / Action
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../store/hook";
import { setUserRole, signOutSuccess } from "../../../../store";

const Header = () => {
  const appName = useSelector(SettingSelector.app_name);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = (role) => {
    console.log("Selected role:", role);
    if (role === "user") {
      dispatch(setUserRole(role));
      navigate("/auth/sign-in/user");
    } else if (role === "employer") {
      dispatch(setUserRole(role));
      navigate("/auth/sign-in/employer");
    }
  };

  const dropdownContent = document.querySelectorAll(".sub-drop");
  if (dropdownContent) {
    dropdownContent.forEach((element) => {
      setTimeout(() => {
        element.style = "";
      }, 100);
    });
  }

  return (
    <>
      <div className="iq-top-navbar border-bottom bg-light">
        <Navbar expand="lg" variant="secondary" className="p-3">
          <Container fluid>
            <Link
              to="/"
              className="d-flex align-items-center gap-2 iq-header-logo"
            >
              <img
                src={logo}
                alt=""
                style={{ width: "210px", height: "auto" }}
              />
            </Link>

            {/* Center navigation links with increased spacing and font size */}
            <Nav className="ms-auto" style={{ gap: "2rem" }}>
              <Nav.Item className="nav-item">
                <Link
                  className="nav-link menu-arrow"
                  to="#"
                  style={{ fontSize: "1.15rem", padding: "0.5rem 1.5rem" }}
                >
                  <span className="nav-text">About</span>
                </Link>
              </Nav.Item>
              <Nav.Item className="nav-item">
                <Link
                  className="nav-link menu-arrow"
                  to="#"
                  style={{ fontSize: "1.15rem", padding: "0.5rem 1.5rem" }}
                >
                  <span className="nav-text">Feature</span>
                </Link>
              </Nav.Item>
              <Nav.Item className="nav-item">
                <Link
                  className="nav-link menu-arrow"
                  to="#"
                  style={{ fontSize: "1.15rem", padding: "0.5rem 1.5rem" }}
                >
                  <span className="nav-text">Pricing</span>
                </Link>
              </Nav.Item>
              <Nav.Item className="nav-item">
                <Link
                  className="nav-link menu-arrow"
                  to="#"
                  style={{ fontSize: "1.15rem", padding: "0.5rem 1.5rem" }}
                >
                  <span className="nav-text">License</span>
                </Link>
              </Nav.Item>
            </Nav>

            {/* Right side buttons */}
            <div className="ms-auto d-flex align-items-center">
              <Button
                variant="primary"
                className="me-2"
                onClick={() => handleClick("user")}
              >
                Sign In
              </Button>
              <Button variant="success" onClick={() => handleClick("employer")}>
                Employer Sign In
              </Button>
            </div>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default Header;
